import { plainText } from '../../../../../../modules/validators';
import { trimSpacesLeft } from '../../../../../../modules/formatters';
import { FormVmItemConfigType } from '../../../../../../infrastructure/form-viewmodel-controller';
import { buildConfigList } from '../../../../../../infrastructure/utils/form-config.utils';

export enum ConnectionTemplateConnectionGroupFieldKey {
    LABEL = 'label'
}

export const FORM_CONFIG = {
    [ConnectionTemplateConnectionGroupFieldKey.LABEL]: {
        labelDescriptor: { id: 'oe.connectionGroupForm.label', defaultMessage: 'Connection Group Label', description: 'Label text' },
        defaultValue: '',
        validators: [plainText.required, plainText.maxLength.short],
        formatters: [trimSpacesLeft]
    },
};

export const connectionTemplateConnectionGroupFormConfigList: FormVmItemConfigType[] = buildConfigList(FORM_CONFIG);
